const config = {
  sessionSampleRate: 1,
  guestRoleArn: "arn:aws:iam::027330894788:role/RUM-Monitor-ap-northeast-1-027330894788-1545923844561-Unauth",
  identityPoolId: "ap-northeast-1:3820b9be-7f29-43d2-82a7-b30e28938432",
  endpoint: "https://dataplane.rum.ap-northeast-1.amazonaws.com",
  telemetries: ["performance","errors"],
  allowCookies: true,
  enableXRay: false
};

const APPLICATION_ID = '7b6443c8-0c45-4b2a-9647-3d7cb3597481';
const APPLICATION_VERSION = '1.0.0';
const APPLICATION_REGION = 'ap-northeast-1';

export default {
  'APPLICATION_ID': APPLICATION_ID,
  'APPLICATION_VERSION': APPLICATION_VERSION,
  'APPLICATION_REGION': APPLICATION_REGION,
  'config': config
}
